module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editable-table"
  }, [_c('RecycleScroller', {
    staticClass: "scroller",
    attrs: {
      "id": "recycle-scroller",
      "items": _vm.sortedRows,
      "item-size": 70
    },
    nativeOn: {
      "scroll": function($event) {
        _vm.wrapperScrollLeft = $event.target.scrollLeft
      }
    },
    scopedSlots: _vm._u([{
      key: "before",
      fn: function() {
        return [_c('div', {
          staticClass: "flex-row fixed",
          style: ({
            '-webkit-transform': 'translateX(' + -_vm.wrapperScrollLeft + 'px)',
            transform: 'translateX(' + -_vm.wrapperScrollLeft + 'px)',
            'clip-path': ("polygon(" + _vm.wrapperScrollLeft + "px 0%, 100% 0%, 100% 100%, " + _vm.wrapperScrollLeft + "px 100%)"),
          }),
          attrs: {
            "id": "fixedHeader"
          }
        }, [_c('div', {
          staticClass: "checkbox-header"
        }), _vm._v(" "), _vm._l((_vm.visibleColumns), function(col) {
          return _c('div', {
            key: col.name,
            staticClass: "headers",
            class: {
              active: _vm.sortKey === col.name
            },
            attrs: {
              "fixed": col.fixed,
              "id": col.displayName.replace(/\s/g, ''),
              "data-column": col.name,
              "prop": col.name,
              "label": col.displayName,
              "class-name": ("column__" + (col.name)),
              "min-width": col.width || 165
            },
            on: {
              "click": function($event) {
                return _vm.sortBy(col.name)
              }
            }
          }, [_vm._v("\n          " + _vm._s(col.displayName) + "\n          "), (
            _vm.sortKey !== col.name || (_vm.sortKey === col.name && _vm.sortDescending)
          ) ? _c('i', {
            staticClass: "icon-chevron-down"
          }) : _vm._e(), _vm._v(" "), (_vm.sortKey === col.name && !_vm.sortDescending) ? _c('i', {
            staticClass: "icon-chevron-up"
          }) : _vm._e()])
        })], 2)]
      },
      proxy: true
    }, {
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "cell table-data flex-row table-first-column"
        }, [_c('div', {
          staticClass: "select",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.selectRow(item)
            }
          }
        }, [_c('input', {
          attrs: {
            "type": "radio"
          },
          domProps: {
            "checked": _vm.selectedItemId === item.id
          }
        })]), _vm._v(" "), _c('generic-input', {
          attrs: {
            "col": _vm.visibleColumns[0],
            "row": item,
            "onChange": _vm.updateRow.bind(null, item.id, _vm.visibleColumns[0].name)
          }
        })], 1), _vm._v(" "), _c('div', {
          key: item.id,
          staticClass: "flex-row",
          attrs: {
            "fixed": item.fixed,
            "data-column": item.name,
            "prop": item.name,
            "label": item.displayName,
            "class-name": ("column__" + (item.name)),
            "min-width": item.width || 154
          }
        }, [_vm._l((_vm.visibleColumns.slice(1)), function(col) {
          return _c('div', {
            key: col.name,
            staticClass: "cell table-data",
            attrs: {
              "data-column": col.name,
              "prop": col.name,
              "label": col.displayName
            }
          }, [_c('generic-input', {
            attrs: {
              "col": col,
              "row": item,
              "onChange": _vm.updateRow.bind(null, item.id, col.name)
            }
          })], 1)
        }), _vm._v(" "), _c('div', [_c('div', {
          staticClass: "duplicate",
          attrs: {
            "title": "duplicate"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.duplicateRow(item)
            }
          }
        }, [_c('Copy', {
          staticClass: "button"
        })], 1)]), _vm._v(" "), _c('div', [_c('div', {
          staticClass: "destroy",
          attrs: {
            "title": "destroy"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteRow(item)
            }
          }
        }, [_c('Delete', {
          staticClass: "button"
        })], 1)])], 2)]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b0808dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditableTable.vue
// module id = 677
// module chunks = 2